export default __webpack_public_path__ + "static/media/item_1.17668ea6.png";